import { Routes } from '@angular/router';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { authenticatedGuard } from './core/guards/authenticated.guard';
import { dynamicAuthGuard } from './core/guards/dynamic-auth.guard';

export const routes: Routes = [
  { path: 'login/callback', component: OktaCallbackComponent },
  {
    path: '',
    loadChildren: () => import('./auth/pages/auth.routes'),
    data: { bodyClass: 'back-parallax-1' },
  },
  {
    path: 'home',
    loadChildren: () => import('./home/pages/home.routes'),
    title: 'Inicio',
    data: { isPrincipalMenu: true },
    canActivate: [dynamicAuthGuard],
  },
  {
    path: 'shared-home',
    loadChildren: () => import('./external-home/pages/home-external.routes'),
    title: 'Inicio',
  },
  {
    path: 'my-points',
    loadChildren: () => import('./my-points/pages/my-points.routes'),
    title: 'Mis puntos',
    data: { bodyClass: 'overflow-x-h', isPrincipalMenu: true },
    canActivate: [dynamicAuthGuard],
  },
  {
    path: 'rewards',
    loadChildren: () => import('./rewards/pages/rewards.routes'),
    title: 'Catálogo',
    data: { isPrincipalMenu: true },
    canActivate: [dynamicAuthGuard],
  },
  {
    path: 'my-orders',
    loadChildren: () => import('./my-orders/pages/my-orders.routes'),
    title: 'Mis pedidos',
    data: { isPrincipalMenu: true },
    canActivate: [dynamicAuthGuard],
  },
  {
    path: 'my-tracking',
    loadChildren: () => import('./request-tracking/pages/my-request-tracking.routes'),
    title: 'Mis solicitudes',
    data: { isPrincipalMenu: true },
    canActivate: [dynamicAuthGuard],
  },
  {
    path: 'how-do-i-win',
    loadChildren: () => import('./how-do-i-win/pages/how-do-i-win.routes'),
    title: 'Concursos',
    data: { bodyClass: 'overflow-x-h', isPrincipalMenu: true },
    canActivate: [dynamicAuthGuard],
  },
  {
    path: 'social',
    loadChildren: () => import('./social/pages/social.routes'),
    title: 'Red social',
    data: { bodyClass: 'overflow-x-h', isPrincipalMenu: true },
    canActivate: [dynamicAuthGuard],
  },
  {
    path: 'achievements',
    loadChildren: () => import('./achievements/pages/achievements.routes'),
    title: 'Reconocimientos',
    data: { isPrincipalMenu: true },
    canActivate: [dynamicAuthGuard],
  },
   {
     path: 'missions',
     loadChildren: () => import('./missions/pages/missions.routes'),
     title: 'Desafíos',
     data: { isPrincipalMenu: true },
     canActivate: [dynamicAuthGuard],
   },
  {
    path: 'help',
    loadChildren: () => import('./help/pages/help.routes'),
    title: 'Ayuda',
    data: { isPrincipalMenu: true },
    canActivate: [dynamicAuthGuard],
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/pages/profile.routes'),
    title: 'Perfil',
    canActivate: [dynamicAuthGuard],
  },
  {
    path: 'cart',
    loadChildren: () => import('./cart/pages/cart.routes'),
    title: 'Carrito',
    canActivate: [dynamicAuthGuard],
  },
  {
    path: 'wishlist',
    loadChildren: () => import('./wishlist/pages/wishlist.routes'),
    title: 'Lista de deseos',
    canActivate: [dynamicAuthGuard],
  },
  {
    path: 'incognito',
    loadChildren: () => import('./incognito/pages/incognito.routes'),
    title: 'Incógnito',
    canActivate: [dynamicAuthGuard],
  },
  {
    path: 'soporte',
    loadChildren: () => import('./support/pages/support.routes'),
    title: 'Soporte'
  },
  {
    path: '**',
    redirectTo: '',
  },
];
